module.exports = __webpack_public_path__ + "img/glo_logo.869ccc58.svg";